import { VANILLA_SETTLING_ASSET_INR } from 'constants/constants';
import { SpotPrices } from 'stores/spotIndia/spotIndia.types';

interface WalletAsset {
  asset_id: number;
  asset_symbol?: string;
  available_balance: string | number;
  balance: string | number;
  [key: string]: any;
}

export const getSpotIndexSymbol = (assetSymbol: string) => {
  const currentSymbol = assetSymbol === 'BTC' ? 'XBT' : assetSymbol;
  return `.DE${currentSymbol}${VANILLA_SETTLING_ASSET_INR}`;
};

/**
 * Calculate asset value in INR using real-time spot prices
 * @param balance - Asset balance
 * @param assetSymbol - Asset symbol (BTC, ETH, etc.)
 * @param spotPrices - Real-time spot prices object
 * @returns Asset value in INR
 */
export const calculateAssetValueInINR = (
  balance: number,
  assetSymbol: string,
  spotPrices: Record<string, number | undefined>
): number => {
  // Skip INR as it's already in INR
  if (assetSymbol === 'INR') {
    return balance;
  }

  // Get the spot index symbol dynamically
  const spotIndexSymbol = getSpotIndexSymbol(assetSymbol);

  if (spotIndexSymbol && spotPrices[spotIndexSymbol]) {
    return balance * spotPrices[spotIndexSymbol];
  }

  return 0;
};

/**
 * Calculate total wallet balance in INR using real-time spot prices
 * @param walletList - List of wallet assets
 * @param spotPrices - Real-time spot prices for BTC and ETH in INR
 * @returns Total balance in INR as a number
 */
export const calculateTotalWalletBalanceInINR = (
  walletList: WalletAsset[],
  spotPrices: SpotPrices
): number => {
  if (!walletList || walletList.length === 0) {
    return 0;
  }
  return walletList.reduce((total, wallet) => {
    const assetSymbol = wallet.asset_symbol || '';
    const balance = parseFloat(String(wallet.balance)) || 0;

    const assetValueInINR = calculateAssetValueInINR(balance, assetSymbol, spotPrices);

    return total + assetValueInINR;
  }, 0);
};

export const convertFromINRtoUSD = (
  inrAmount: number,
  inrConversionRate: number
): number => {
  if (!inrConversionRate || inrConversionRate === 0) {
    return 0;
  }
  return inrAmount / inrConversionRate;
};
